import React from "react";
const LoaderIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
  "path",
  {
    id: "file-upload-loader-icon-path",
    d: "M14.064 5.948l1.518-.507A8 8 0 1 1 10.473.39l-.506 1.519a6.4 6.4 0 1 0 4.097 4.04z"
  }
)), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(4 4)" }, /* @__PURE__ */ React.createElement("mask", { id: "file-upload-loader-mask", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#file-upload-loader-icon-path" })), /* @__PURE__ */ React.createElement("use", { fill: "currentColor", xlinkHref: "#file-upload-loader-icon-path" }), /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M-4-4h24v24H-4z", mask: "url(#file-upload-loader-mask)" })));
export {
  LoaderIcon
};
//# sourceMappingURL=loader-icon.js.map
